import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { ProfileContent } from './Profile';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <ProfileContent pubkey={decoded.data as string} />;

    case 'nprofile': {
      const data = decoded.data as { pubkey: string };
      return <ProfileContent pubkey={data.pubkey} />;
    }

    case 'note':
    case 'nevent':
    case 'naddr':
      // Picture events would be viewed via the feed/album, not direct note links
      return <NotFound />;

    default:
      return <NotFound />;
  }
}
